import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * React translation of the shared {@code pages/category/productListPage.jsp},
 * which is rendered by BOTH the category route ({@code /c/{categoryCode}}) and
 * the PLP route ({@code /plp/{categoryCode}}).
 *
 * Structure-copy parity (slot order, body placement, and JSP wrapper ids/classes
 * are preserved from the JSP):
 *
 * <ol>
 *   <li>{@code MoreInfoSlot} inside a hidden {@code #moreInfoTab} /
 *     {@code #contentStream} wrapper (read at runtime by the ProductListPage
 *     "More Information" tab via {@code useServerSideContent("#moreInfoTab")}).</li>
 *   <li>{@code ImageHeaderSlot} inside {@code #imageHeaderComponentSlot}
 *     (the ProductListPage removes this element when empty).</li>
 *   <li>the route body at the {@code #root_page} position, replacing the former
 *     {@code ProductListPage} React island mount.</li>
 *   <li>{@code DescriptionParagraph} after the body.</li>
 * </ol>
 *
 * Registered under two real backend templateUids ({@code CategoryPageTemplate} and
 * {@code PlpPageTemplate}) since the two routes share this one JSP structure.
 */
export function ProductListPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <>
      <div hidden>
        <div id="moreInfoTab">
          <article id="contentStream" className="scha__cms mt-30">
            <div className="ContentStreamSlot">{slots.renderSlot("MoreInfoSlot")}</div>
          </article>
        </div>
      </div>
      <div className="js__page-plp jsp__page-plp">
        <div id="imageHeaderComponentSlot">
          <div className="js__scha__plp-ihs-slot">{slots.renderSlot("ImageHeaderSlot")}</div>
        </div>
        <div id="root_page">{body}</div>
      </div>
      <div id="descriptionParagraph">{slots.renderSlot("DescriptionParagraph")}</div>
    </>
  );
}
